import { ApolloClient, HttpLink, InMemoryCache } from "apollo-boost";
import { IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";
import { createUploadLink } from "apollo-upload-client";
import { canUseDOM } from "exenv";
import Cookie from "js-cookie";
import { fetch } from "whatwg-fetch";

import schema from "../../../../../app/graphql/schema.json";
import graphqlEndpoint from "../../constants/graphql-endpoint";

const apolloHeaders = { os: "web" };

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema?.data
});

const setAuthorizationHeader = () => {
  if (canUseDOM) {
    const userAuthToken = Cookie.get("user_auth_token", {
      domain: global.location.host
    });
    if (userAuthToken) {
      apolloHeaders.Authorization = userAuthToken;
    }
  }
};

setAuthorizationHeader();

const authLink = setContext((_, { headers }) => {
  setAuthorizationHeader();

  return {
    headers: {
      ...headers,
      ...apolloHeaders
    }
  };
});

const inMemoryCache = new InMemoryCache({ fragmentMatcher });

const httpLink = new HttpLink({
  uri: graphqlEndpoint,
  fetch
});

const uploadLink = createUploadLink({
  uri: graphqlEndpoint,
  fetch
});

const baseLink = authLink.concat(httpLink);

const uploadFileLink = authLink.concat(uploadLink);

const createNewApolloClient = (options = {}, link = baseLink) =>
  new ApolloClient({
    link,
    cache: inMemoryCache,
    ...options
  });

const apolloClient = createNewApolloClient();

const apolloUploadClient = createNewApolloClient({}, uploadFileLink);

export {
  createNewApolloClient,
  inMemoryCache,
  apolloClient as default,
  apolloUploadClient,
  fragmentMatcher
};
